import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const agent = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agent/background?` + params,
        method: 'GET'
    })
}


export const addRedPacket = (params) => {
    //params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/new`,
        method: 'POST',
        data: params
    })
}

export const redPacket = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/?` + params,
        method: 'GET'
    })
}

export const withdrawalConfig = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_deposit/find_withdrawal_config?` + params,
        method: 'GET'
    })
}

export const withdrawalConfigEdit = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_deposit/edit_withdrawal_config`,
        method: 'POST',
        data: params
    })
}

export const redPacketPay = (params) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/redPacketPay`,
        method: 'POST',
        data: params
    })
}
export const downloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/downloadExcelByAgent?` + params,
        method: 'GET'
    })
}
export const pass = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/pass/${id}`,
        method: 'GET'
    })
}
export const refuse = (data) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/refuse`,
        method: 'PUT',
        data: data
    })
}







